export const Weight = {
  REGULAR: 3,
  SEMIBOLD: 2,
  BOLD: 1,
} as const;

export type Weight = Union<typeof Weight>;

export const Level = {
  FIRST: 1,
  SECOND: 2,
  THIRD: 3,
} as const;

export type Level = Union<typeof Level>;
